import FormattedText from '@nespresso/catalog-components-react/containers/FormattedText';
import styles from './CollectionDetails.module.scss';
import type { Category } from '@/domain/Category';
import type { Product } from '@/domain/Product';
import { CardModalIdProvider } from '../cards/hooks/useCardModalId.tsx';
import ProductCardsGrid from '../cards/ProductCardsGrid/ProductCardsGrid.tsx';
import type { PromotionCardDefinition } from '../config';

export function CollectionDetails({
  collection,
  productsForCollection,
  promotionCardsByCollection,
  displayCollectionSubheader
}: {
  collection: Category;
  productsForCollection: Product[];
  promotionCardsByCollection: PromotionCardDefinition[];
  displayCollectionSubheader: boolean;
}) {
  return (
    <section
      key={collection.code}
      data-collection-id={collection.id}
      data-collection-code={collection.code}
    >
      {/* Per card modals need to have an id which is unique on the page, not just the product */}
      <CardModalIdProvider collectionCode={collection.code}>
        <h2 class={styles.heading}>{collection?.name}</h2>

        {collection?.description && displayCollectionSubheader && (
          <FormattedText as="p" className={styles.collectionDescription}>
            {collection?.description}
          </FormattedText>
        )}

        <ProductCardsGrid
          products={productsForCollection}
          title={collection?.name}
          promotionCards={promotionCardsByCollection}
          displayingCollection
        />
      </CardModalIdProvider>
    </section>
  );
}
